/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
  (function () {

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  
  })();
  
$(document).on('mrkCartUpdated', function(){
  // Detect changes on any of the cart attribute inputs
  $('.cart-attribute__field input').on('change', function() {
    console.log('hello');
    updateCartAttributes();
  });
});

function updateCartAttributes() {
  var attributes = {};

  // Loop through the inputs to gather attributes
  $('.cart-attribute__field input').each(function() {
    var name = $(this).attr('name').replace('attributes[', '').replace(']', '');
    var value = $(this).val();
    attributes[name] = value;
  });

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      attributes: attributes
    },
    dataType: 'json',
    success: function(cart) {
      // console.log('Cart attributes updated successfully!', cart);
    },
    error: function() {
      console.error('There was an error updating the cart attributes.');
    }
  });
}